// Currency formatting utility for Philippine Peso
export const formatCurrency = (amount) => {
  return `₱${Number(amount).toLocaleString('en-PH', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  })}`;
};

export const formatCurrencyCompact = (amount) => {
  return `₱${Number(amount).toFixed(2)}`;
};
